export default __webpack_public_path__ + "assets/_Chapters/CTeileSortiment/Handwerkzeuge/stahlwille.jpg";